
// ANIMATE
 
import "animate.css"; 

// 

import "./components/_toggleClass";
import "./components/_fetchDuration";
import "./components/_lightbox";
import "./components/_tournament"; 
import "./components/_imageInput";
import "./components/_social";
import "./components/_embed";
import "./components/_activeNav";
import "./components/_loadAjax";

$(function(){
    $("#languages > .languages__current").toggleClass({
        objToggle: $("#languages").parents("li"),
        classToggle: "slideUp"
    });
    
    if ($(".article").next(".viewmore").length > 0) {
        $(".article").next(".viewmore").toggleClass({
            objToggle: $(".article"),
            classToggle: "article--limited",
            animate: {maxHeight: 420},
            animateToggle: {maxHeight: 9999}
        });

        $(".viewmore__button--expanded").on("click", () => {
            $('[data-scroll-link="#overview"]').trigger("click"); 
        })
    }
    
    if ($(".streams__live > .control > .slide").length > 0) {
        $(".streams__live > .control > .slide").toggleClass({
            objToggle: $(".streams__live"),
            classToggle: "hide-lineups"
        }) 
    }
    
    if ($("[data-burger]").length > 0) {
        $("[data-burger]").each(function(){
            $(this).toggleClass({
                objToggle: $(this).parent()
            })
            $(this).toggleClass({
                objToggle: $(this).children(".hamburger"),
                classToggle: 'is-active'
            })
            $(this).toggleClass({
                objToggle: $(".followIfMobile")
            })
        })
    }


    $("[data-youtube-fetch-duration]").each(function(){
        $(this).fetchDuration(); 
    }) 
    
    // 
    
    if ($("[data-lightbox]").length > 0) {
        $("[data-lightbox]").each(function(){
            $(this).lightBox({
                objLightBox: $(this).attr('href'),
                type: $(this).data('lightbox-type')
            });
        }); 
    }
    
    //
    
    
    if ($(".dndbracket").length > 0) {
        $('.matches__tab > ul > li > [type="hidden"]').each(function() {
            if ($(this).val() != "") {
                let dataRound = $(this).prev("a").data("round");
                $(this).initTournamentDiagram({
                    objAppend: $('.matches__content[data-round="'+dataRound+'"] > .container > .dndbracket')
                });
            }
        })
    }
    
    
    if ($('.matches__tab').length > 0) {
        $('.matches__tab').find('a').on('click', function(e) {
            $(this).parent().siblings().children('a').removeClass('active');
            $(this).addClass('active');
    
            let dataRound = $(this).data('round');
    
            $('.matches__content').removeClass("active");
            $('.matches__content[data-round="'+dataRound+'"]').addClass("active");
        });
    }
    
    if ($('.buttonListExtend').length > 0) {
        $(".buttonListExtend").on("click", function(){
            $(this).parent().prev(".list").removeClass(".limited--5");
            $(this).remove();
        })
    }
    
    
    if ($('input[type="file"]').length > 0) {
        $('input[type="file"]').imageInput();
    }
    
    //
    
    
    $("[data-callsocial]").each(function(){
        $(this).callSocial();
    })
    
    // 
    
    
    $("[data-embed]").each(function(){
        $(this).embed({
            objToEmbed: $(this).children(".video__content")
        });
    }) 
    
    
    
    if ($(".page").length > 0) {
        $(".page").eq(0).activeNav(); 
    }
    
    $("[data-loadajax]").each(function(){
        $(this).loadAjax({
            ajaxUrl: $(this).data("loadajax-url"),
            affectedObj: $(this).data("loadajax-affectedobj"),
            type: $(this).data("loadajax-type"),
            loadingDomList: $(this).data("loadajax-loadingdomlist")
        });
    }) 
    
})
